var valid = false;
if (typeof jQuery === "undefined") {
  // jQuery is NOT available
  var valid = false;
} else {
  var version = jQuery().jquery;
  var groups = /(\d+)\.(\d+)/.exec(version);
  if (groups[1] > 1 || groups[2] >= 5) valid = true;
}

if (valid) {
  var remoteHostline = "//gift-reggie.eshopadmin.com";
  var serverHostline = "/apps/giftregistry";
  var cartJS = "/cart.js";
  var accountLine = "/account";

  if (/^\/mock/.test(window.location.pathname)) {
    // For the test server. People in production, you can ignore this.
    serverHostline = "/mock/proxy";
    remoteHostline = "http://localhost:3001";
    cartJS = "/mock/cart.js";
    accountLine = "/mock/account";
  }

  var giftReggieCookieName = "giftreggie_session_cookie";

  function setCookie(c_name, value, exdays) {
    try {
      localStorage.setItem(c_name, value);
    } catch (ex) {
      console.warn("GR setCookie en localStorage falló", ex);
    }
    if (c_name === "giftreggie-address") {
      try {
        // handle legacy theme code that expects this to be set
        document.cookie = c_name + "=" + encodeURIComponent(value) + "; path=/";
      } catch (ex) {
        // do nothing
      }
    }
  }

  function getCookie(c_name) {
    try {
      return localStorage.getItem(c_name) || null;
    } catch (ex) {
      console.warn("GR getCookie en localStorage falló", ex);
      return null;
    }
  }

  function getSessionId() {
    var value = getCookie(giftReggieCookieName);
    if (!value || value == "undefined" || value == "null") return null;
    return value;
  }

  function getServerTime() {
    return Math.floor(new Date().getTime() / 1000);
  }

  function signOAuth(ajaxOptions, shopifyId, sharedSecret) {
    return ajaxOptions;
  }

  function deleteCookie(c_name) {
    try {
      return localStorage.removeItem(c_name);
    } catch (ex) {
      console.warn("GR deleteCookie en localStorage falló", ex);
    }
  }

  (function ($) {
    // This is bad, but actually works without badgering our servers.
    // If shopify stays relatively consistent, we'll keep this, otherwise we should move this to our servers.
    loggedInCheckHack = function () {
      // Here's how we do. We ajax to /account.js. If we're logged in, we'll get a content-type that's application/json.
      // If we're not, we'll get a redirect to /account/login, which'll be served up as text/html. We can check these via getResponseHeader.
      var deferred = $.Deferred();
      $.ajax({ url: accountLine + ".js", dataType: "html" }).done(function (
        data,
        status,
        xhr
      ) {
        if (/html/.test(xhr.getResponseHeader("Content-Type")))
          deferred.reject();
        else deferred.resolve();
      });
      return deferred;
    };

    showDialog = function (type, cookie) {
      if (cookie && cookie.registry_id)
        $("#giftreggie-" + type + (cookie.admin ? "-admin" : "")).slideDown();
      else if (cookie && cookie.wishlist_id)
        $("#giftreggie-" + type + "-wishlist").slideDown();
    };

    registryError = function (message) {
      $(".giftreggie-product-status").html(
        "<div class='error'>" + message + "</div>"
      );
    };

    registrySuccess = function (message) {
      $(".giftreggie-product-status").html(
        "<div class='success'>" + message + "</div>"
      );
    };
    wishlistSuccess = function (message) {
      return registrySuccess(message);
    };
    wishlistError = function (message) {
      return registryError(message);
    };

    var savedReggieQuantities = {};
    updateProductTable = function (cookie, product, registry) {
      var admin = cookie.admin;
      var isWishlist = cookie["wishlist_id"] ? 1 : 0;
      var variant_index = {};
      if (!isWishlist) {
        if (registry && registry.products.length > 0) {
          for (var i = 0; i < registry.products[0].variants.length; ++i) {
            variant_index[registry.products[0].variants[i].id] =
              registry.products[0].variants[i];
            savedReggieQuantities[registry.products[0].variants[i].id] =
              registry.products[0].variants[i].quantity;
          }
        }
        if (admin) {
          for (var i = 0; i < product.variants.length; ++i) {
            var variant = product.variants[i];
            var variant_title = variant.title;
            if (variant_title == "Default Title" || variant_title == "Default")
              variant_title = product.title;
            $("#giftreggie-product-table").append(
              "<input type='hidden' id='giftreggie-product-id' value='" +
                product.id +
                "'/>"
            );
            $("#giftreggie-product-table").append(
              "<div class='giftreggie-product-row'>\
						<div class='giftreggie-title'>" +
                variant_title +
                "</div><div class='giftreggie-purchased'>" +
                (variant_index[variant.id]
                  ? variant_index[variant.id].purchased
                  : 0) +
                "</div> / <div class='giftreggie-quantity'><input type='text'class='giftreggie-variant-quantity' maxlength=3 value='" +
                (variant_index[variant.id]
                  ? variant_index[variant.id].quantity
                  : 0) +
                "'/></div>\
						<input type='hidden' class='giftreggie-variant-id' value='" +
                variant.id +
                "'/></div>"
            );
          }
          if (registry) {
            $("#giftreggie-product-admin-change").show();
            $("#giftreggie-product-admin-add").hide();
          } else {
            $("#giftreggie-product-admin-change").hide();
            $("#giftreggie-product-admin-add").show();
          }
        } else {
          for (var i = 0; i < product.variants.length; ++i) {
            var variant = product.variants[i];
            if (!variant_index[variant.id]) continue;
            var registry_variant = variant_index[variant.id];

            var variant_title = variant.title;
            if (variant_title == "Default Title" || variant_title == "Default")
              variant_title = product.title;
            $("#giftreggie-variants, #giftreggie-variants-wishlist").append(
              "<li><span>" +
                variant_title +
                "</span> <span>" +
                (registry_variant.quantity - registry_variant.purchased) +
                "</span></li>"
            );
          }
        }
      } else {
        var titles = {};
        for (var i = 0; i < product.variants.length; ++i) {
          var variant = product.variants[i];
          var variant_title = variant.title;
          if (variant_title == "Default Title") variant_title = product.title;
          titles[variant.id] = variant_title;
          $("#giftreggie-product-table").append(
            "<input type='hidden' id='giftreggie-product-id' value='" +
              product.id +
              "'/>"
          );
          $("#giftreggie-variants-wishlist").append(
            "<div class='giftreggie-product-row'>\
					<div class='giftreggie-title'>" +
              variant_title +
              "</div><div class='giftreggie-wishlist'><input data-id='" +
              variant.id +
              "' type='button' class='wishlisttoggle addbutton' value='✓'/></div>"
          );
        }
        var variant_hash = {};
        for (var i = 0; i < cookie.variant_ids.length; ++i)
          variant_hash[cookie.variant_ids[i]] = 1;
        $("#giftreggie-variants-wishlist .addbutton").each(function () {
          if (variant_hash[$(this).attr("data-id")]) {
            $(this).removeClass("addbutton");
            $(this).addClass("rmbutton");
            $(this).val("×");
          }
        });
        $(".wishlisttoggle").click(function () {
          var button = $(this);
          $(".wishlisttoggle").attr("disabled", "disabled");
          if ($(this).hasClass("addbutton")) {
            // Add to wishlist.
            $.ajax({
              url: serverHostline + "/api/wishlist/add",
              type: "POST",
              dataType: "json",
              contentType: "json",
              data: JSON.stringify({ id: button.attr("data-id") }),
            })
              .done(function () {
                wishlistSuccess(
                  "Se agregó " +
                    titles[button.attr("data-id")] +
                    " a tu lista de deseos."
                );
                button.removeClass("addbutton");
                button.addClass("rmbutton");
                button.val("×");
                cookie.variant_ids.push(button.attr("data-id"));
                setCookie("giftreggie-logged", JSON.stringify(cookie));
                $(".wishlisttoggle").removeAttr("disabled");
              })
              .fail(function (jqXHR) {
                wishlistError(
                  "No se pudo modificar la lista de deseos: " +
                    JSON.parse(jqXHR.responseText).error
                );
                $(".wishlisttoggle").removeAttr("disabled");
              });
          } else {
            // Remove from wishlist.
            $.ajax({
              url: serverHostline + "/api/wishlist/remove",
              type: "POST",
              dataType: "json",
              contentType: "json",
              data: JSON.stringify({ id: button.attr("data-id") }),
            })
              .done(function () {
                wishlistSuccess(
                  "Se eliminó " +
                    titles[button.attr("data-id")] +
                    " de tu lista de deseos."
                );
                button.removeClass("rmbutton");
                button.addClass("addbutton");
                button.val("✓");
                for (var i = cookie.variant_ids.length - 1; i >= 0; i--) {
                  if (cookie.variant_ids[i] === button.attr("data-id")) {
                    cookie.variant_ids.splice(i, 1);
                    break;
                  }
                }
                setCookie("giftreggie-logged", JSON.stringify(cookie));
                $(".wishlisttoggle").removeAttr("disabled");
              })
              .fail(function (jqXHR) {
                wishlistError(
                  "No se pudo modificar la lista de deseos: " +
                    JSON.parse(jqXHR.responseText).error
                );
                $(".wishlisttoggle").removeAttr("disabled");
              });
          }
          return false;
        });
      }
    };

    modifyProductRegistry = function (registryId) {
      var variantList = $.map(
        $.grep($(".giftreggie-product-row"), function (e, i) {
          var id = $(e).children(".giftreggie-variant-id").val();
          var savedQuantity = savedReggieQuantities[id]
            ? savedReggieQuantities[id]
            : 0;
          var newQuantity = $(e).find(".giftreggie-variant-quantity").val();
          return savedQuantity != newQuantity;
        }),
        function (value) {
          return {
            id: $(value).children(".giftreggie-variant-id").val(),
            quantity: $(value).find(".giftreggie-variant-quantity").val(),
          };
        }
      );
      if (variantList.length > 0) {
        $(".giftreggie-popup input").attr("disabled", "disabled");
        $(".giftreggie-popup .spinner").show();
        $.ajax({
          url: serverHostline + "/api/registry/" + registryId + "/product",
          type: "PUT",
          dataType: "json",
          contentType: "json",
          data: JSON.stringify({
            products: [
              {
                id: $("#giftreggie-product-id").val(),
                variants: variantList,
              },
            ],
          }),
        })
          .done(function () {
            registrySuccess("¡Registro modificado exitosamente!");
            for (var i = 0; i < variantList; ++i)
              savedReggieQuantities[variantList[i].id] =
                variantList[i].quantity;
            $("#giftreggie-product-admin-add").hide();
            $("#giftreggie-product-admin-change").show();
            $(".giftreggie-popup input").removeAttr("disabled");
            $(".giftreggie-popup .spinner").hide();
          })
          .fail(function () {
            registryError(
              "No se pudo modificar el registro. Por favor, intenta ir a <a href='" +
                serverHostline +
                "'>esta página</a> y luego regresar. Disculpas por el error. Si el problema persiste, por favor contacta al propietario de la tienda."
            );
            $(".giftreggie-popup input").removeAttr("disabled");
            $(".giftreggie-popup .spinner").hide();
          });
      } else {
        registryError("No se realizaron cambios al registro.");
      }
    };

    removeProductRegistry = function (registryId) {
      var variantList = $.map(
        $.grep($(".giftreggie-product-row"), function (e, i) {
          var id = $(e).children(".giftreggie-variant-id").val();
          var savedQuantity = savedReggieQuantities[id]
            ? savedReggieQuantities[id]
            : 0;
          return savedQuantity > 0;
        }),
        function (value) {
          return {
            id: $(value).children(".giftreggie-variant-id").val(),
            quantity: $(value).find(".giftreggie-variant-quantity").val(),
          };
        }
      );

      $(".giftreggie-popup input").attr("disabled", "disabled");
      $(".giftreggie-popup .spinner").show();
      $.ajax({
        url:
          serverHostline +
          "/api/registry/" +
          registryId +
          "/product/" +
          $("#giftreggie-product-id").val(),
        type: "DELETE",
        dataType: "json",
        contentType: "json",
        data: JSON.stringify({
          products: [
            {
              id: $("#giftreggie-product-id").val(),
              variants: $.map($(".giftreggie-product-row"), function (value) {
                return {
                  id: $(value).children(".giftreggie-variant-id").val(),
                  quantity: $(value).find(".giftreggie-variant-quantity").val(),
                };
              }),
            },
          ],
        }),
      })
        .done(function () {
          registrySuccess("¡Producto eliminado del registro exitosamente!");
          for (var i = 0; i < variantList.length; ++i)
            savedReggieQuantities[variantList[i].id] = 0;
          $("#giftreggie-product-admin-add").show();
          $("#giftreggie-product-admin-change").hide();
          $("#giftreggie-product-table input[type='text']").val("0");
          $(".giftreggie-popup input").removeAttr("disabled");
          $(".giftreggie-popup .spinner").hide();
        })
        .fail(function () {
          registryError(
            "No se pudo eliminar el producto del registro. Por favor, intenta ir a <a href='" +
              serverHostline +
              "'>esta página</a> y luego regresar. Disculpas por el error. Si el problema persiste, por favor contacta al propietario de la tienda."
          );
          $(".giftreggie-popup input").removeAttr("disabled");
          $(".giftreggie-popup .spinner").hide();
        });
    };

    // This should be cleared upon checkout. If you checkout in a non-standard way, then
    clearGiftreggieSession = function () {
      deleteCookie("giftreggie-logged");
    };

    $(document).ready(function () {
      var url = window.location.pathname;
      var loggedRegistry = getCookie("giftreggie-logged");

      if (loggedRegistry != null) {
        var loggedJSON = JSON.parse(loggedRegistry);
        var registryId = loggedJSON.registry_id;
        registryId = registryId ? registryId : "";
        var registryName = loggedJSON.registry_title;
        var admin = loggedJSON.admin;
        var hasCollections = /collections/.test(url);
        var hasProducts = /products/.test(url);
        var isWishlist = loggedJSON["wishlist_id"] ? 1 : 0;

        // Don't throw up the pop up if they have the button on the page.
        if ($(".gift-reggie-wishlist-button").length > 0 && isWishlist) {
          return;
        }

        $.ajax({ url: cartJS, dataType: "json", contentType: "json" }).done(
          function (data) {
            var token = data.token;
            if (token != null && loggedJSON.token == null) {
              loggedJSON.token = token;
              setCookie("giftreggie-logged", JSON.stringify(loggedJSON));
            } else if (token != loggedJSON.token) {
              clearGiftreggieSession();
            }
          }
        );
        if (loggedJSON.admin) {
          loggedInCheckHack().fail(function () {
            clearGiftreggieSession();
            if (hasCollections || hasProducts) window.location.reload();
          });
        }
        $("body").append(
          "<style>\
					.giftreggie-popup { background-color: white; padding: 10px; border-left: 1px solid black; border-bottom: 1px solid black; position: fixed; display: none; right: 0; top: 0; width: 350px; z-index:10000; }\
					.giftreggie-popup-close { cursor: pointer; top: 0px; right: 10px; position: absolute; }\
					.giftreggie-popup-minimize { cursor: pointer; top: 0px; right: 24px; position: absolute; }\
					#giftreggie-variants li span:first-child:after { content:' x '; }\
					#giftreggie-product-table > div { display: block; border-bottom: 1px solid #AAA; }\
					#giftreggie-product-table > div > div { display: inline-block; } \
					#giftreggie-product-table > div > div:first-child { width: 70%; } \
					.giftreggie-product-row div { display: inline-block;  }\
					.giftreggie-product-row div:first-child { width: 70%; }\
					.giftreggie-product-row input { width: 65px; }\
					.giftreggie-popup h2 { margin-top: 0; }\
					.giftreggie-product-status { margin-top: 10px; } \
					.giftreggie-product-status .error { color: red; }\
					.giftreggie-product-status .success { color: green; }\
					.giftreggie-popup .spinner { display: none; }\
					#giftreggie-product-admin { overflow-y: scroll; max-height: 80%; }\
					.giftreggie-popup input[type='button'].addbutton { background:none; background-color: #FFF; border: #777 1px solid; }\
					.giftreggie-popup input[type='button'].rmbutton { background:none; background-color: #AAA; border: #333 1px solid; }\
					.giftreggie-popup-stop { margin: 0 auto; display: block; margin-bottom: 12px; }\
					.giftreggie-popup .t4s_as_button, .giftreggie-popup button, .giftreggie-popup input[type='button']:not(.t4s-btn), .giftreggie-popup input[type='reset'], .giftreggie-popup input[type='submit']:not(.t4s-btn) { background-color: #e3eac6!important; }\
				</style>\
				<div class='giftreggie-popup' id='giftreggie-product'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body' id='giftreggie-product-info'>\
						<h2 class='giftreggie-registry-notification'></h2>\
						<input type='button' class='giftreggie-popup-stop' value='Dejar de Comprar para este Registro'/>\
						<p>¡Este producto está en el registro! A continuación se muestra una lista de los artículos seleccionados. Para realizar una compra, elige artículos de la página del producto y agrégalos al carrito. Cualquier artículo comprado será marcado como completado en el registro.</p>\
						<ul id='giftreggie-variants'>\
						</ul>\
					</div>\
				</div>\
				\
				<div class='giftreggie-popup' id='giftreggie-collection'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body' id='giftreggie-collection-info'>\
						<h2 class='giftreggie-registry-notification'></h2>\
						<input type='button' class='giftreggie-popup-stop' value='Dejar de Comprar para este Registro'/>\
						<p>¡Bienvenido al modo de navegación del registro " +
            registryName +
            "! Mientras navegas por el sitio, aparecerá una ventana emergente como esta, informándote si el producto que estás viendo está o no en el registro.</p>\
					</div>\
				</div>\
				\
				<div class='giftreggie-popup' id='giftreggie-product-admin'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body'>\
						<h2 class='giftreggie-registry-notification'></h2>\
						<input type='button' class='giftreggie-popup-stop' value='Dejar de Administrar este Registro'/>\
						<!-- If we're not on the registry. -->\
						<div style='display:none' id='giftreggie-product-admin-add'>\
							<p>¡Este producto no está en el registro! Completa este formulario para agregarlo.</p>\
							<div class='giftreggie-product-status'></div>\
							<p>\
								<input type='button' style='margin:0' onclick='modifyProductRegistry(" +
            registryId +
            ");' value='Agregar al Registro' /></input>\
								<span class='spinner'><img src='" +
            remoteHostline +
            "/static/img/catalyst/ajax-loader-f5f5f5.gif'/ ></span>\
							</p>\
						</div>\
						<!-- If we are on the registry. -->\
						<div style='display:none' id='giftreggie-product-admin-change'>\
							<p>¡Este producto ya está en el registro! Puedes modificar sus propiedades a continuación.</p>\
							<div class='giftreggie-product-status'></div>\
							<p>\
								<input type='button' onclick='modifyProductRegistry(" +
            registryId +
            ");' value='Modificar Cantidades del Registro'></input>\
								<input type='button' onclick='removeProductRegistry(" +
            registryId +
            ");' value='Eliminar del Registro'></input>\
								<span class='spinner'><img src='" +
            remoteHostline +
            "/static/img/catalyst/ajax-loader-f5f5f5.gif'/ ></span>\
							</p>\
						</div>\
						<div id='giftreggie-product-table'>\
							<div>\
								<div>Título de Variante</div><div>Tiene / Quiere</div>\
							</div>\
						</div>\
					</div>\
				</div>\
				\
				<div class='giftreggie-popup' id='giftreggie-collection-admin'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body'>\
						<h2 class='giftreggie-registry-notification'></h2>\
						<input type='button' class='giftreggie-popup-stop' value='Dejar de Administrar este Registro'/>\
						<p>Bienvenido al modo de navegación de administrador de tu registro. Mientras navegas por el sitio, cuando llegues a una página de producto, se te pedirá que agregues el producto al registro (o no). Este diálogo aparecerá en la esquina superior derecha de cada página de producto válida. Para comenzar, simplemente haz clic en cualquiera de los productos a continuación.</p>\
					</div>\
				</div>\
				<div class='giftreggie-popup' id='giftreggie-collection-wishlist'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body'>\
						<h2>Actualmente estás administrando tu <a href='" +
            serverHostline +
            "/wishlist'>lista de deseos</a>.</h2>\
						<input type='button' class='giftreggie-popup-stop' value='Dejar de administrar tu lista de deseos.'/>\
						<p>Bienvenido al modo de navegación de administrador de tu lista de deseos. Mientras navegas por el sitio, cuando llegues a una página de producto, se te pedirá que agregues el producto a la lista de deseos (o no). Este diálogo aparecerá en la esquina superior derecha de cada página de producto válida. Para comenzar, simplemente haz clic en cualquiera de los productos a continuación.</p>\
					</div>\
				</div>\
				<div class='giftreggie-popup' id='giftreggie-product-wishlist'>\
					<a class='giftreggie-popup-minimize'>&ndash;</a>\
					<a class='giftreggie-popup-close'>&times;</a>\
					<div class='giftreggie-popup-body' id='giftreggie-product-info'>\
						<h2>Actualmente estás administrando tu <a href='" +
            serverHostline +
            "/wishlist'>lista de deseos</a>.</h2>\
						<input type='button' class='giftreggie-popup-stop' value='Dejar de administrar tu lista de deseos.'/>\
						<p>Puedes usar los siguientes controles a continuación para modificar si este producto está o no en tu lista de deseos.</p>\
						<p>Un <input class='addbutton' type='button' value='✓'/> junto a un artículo indica que no está en tu lista de deseos. Haz clic para agregarlo a tu lista.<br/>\
						Un <input class='rmbutton' type='button' value='×'/> junto a un artículo indica que está en tu lista de deseos. Haz clic para eliminar el artículo de tu lista.</p>\
						<div class='giftreggie-product-status'></div>\
						<ul id='giftreggie-variants-wishlist'>\
						</ul>\
					</div>\
				</div>"
        );
        $(".giftreggie-registry-notification").html(
          "Actualmente estás " +
            (admin ? "administrando" : "comprando para") +
            " <a href='" +
            serverHostline +
            "/registry/" +
            registryId +
            "'>" +
            registryName +
            "</a>."
        );
        if (hasCollections || hasProducts) {
          if (!hasProducts) {
            // Display first dialog if we don't have a cookie already doing it.
            //if (getCookie("gift-reggie-initial") == null) {
            showDialog("collection", loggedJSON);
            //	setCookie("gift-reggie-initial", 0);
            //}
          } else {
            var groups = /(.*)\/products\/([\w-]+)/.exec(url);
            if (groups && groups.length > 2) {
              var prior = groups[1];
              var handle = groups[2];
              var cart = {};
              $.ajax({
                url: prior + "/products/" + handle + ".js",
                dataType: "json",
              }).done(function (product) {
                if (!isWishlist) {
                  $.ajax({
                    url:
                      serverHostline +
                      "/api/registry/" +
                      registryId +
                      "/product/" +
                      product.id,
                    dataType: "json",
                  })
                    .done(function (registry) {
                      var shouldShow = false;
                      for (var i = 0; i < registry.products.length; ++i) {
                        for (
                          var j = 0;
                          j < registry.products[i].variants.length;
                          ++j
                        ) {
                          if (
                            parseInt(
                              registry.products[i].variants[j].purchased
                            ) <
                            parseInt(registry.products[i].variants[j].quantity)
                          )
                            shouldShow = true;
                        }
                      }
                      if (shouldShow) {
                        showDialog("product", loggedJSON);
                        updateProductTable(loggedJSON, product, registry);
                      }
                    })
                    .fail(function () {
                      if (admin) {
                        showDialog("product", loggedJSON);
                        updateProductTable(loggedJSON, product);
                      }
                    });
                } else {
                  updateProductTable(loggedJSON, product);
                  showDialog("product", loggedJSON);
                }
              });
            }
          }
        }
        $(".giftreggie-popup-close").click(function () {
          $(this).parents(".giftreggie-popup").slideUp();
        });
        var initial_width = $(".giftreggie-popup").width();
        var initial_height;
        $(".giftreggie-popup-minimize").click(function () {
          var selector = $(this).parent().children(".giftreggie-popup-body");
          if (selector.is(":visible")) {
            initial_height = selector.height();
            selector.animate({ height: 0 }, 400, "swing", function () {
              $(this).hide();
            });
            $(".giftreggie-popup").css("overflow-y", "hidden");
            $(".giftreggie-popup").animate({ width: 65 });
          } else {
            selector.show();
            selector.animate({ height: initial_height });
            //$('.giftreggie-popup').removeAttr('style');
            $(".giftreggie-popup").css("overflow-y", "auto");
            $(".giftreggie-popup").animate({ width: initial_width });
          }
        });
        if (window.giftreggiePopupDone) window.giftreggiePopupDone.resolve();
        $(".giftreggie-popup-stop").click(function () {
          var button = $(this);
          $(this).attr("disabled", "disabled");
          $.ajax({
            url: "/cart/update.js",
            type: "POST",
            dataType: "json",
            data: {
              "attributes[registry_id]": "",
              "attributes[registry_admin]": "",
            },
          })
            .done(function () {
              button.parents(".giftreggie-popup").slideUp();
              deleteCookie("giftreggie-logged");
              deleteCookie("giftreggie-address");
            })
            .fail(function () {
              button.removeAttr("disabled");
            });
        });
      }
    });
  })(jQuery);
} else {
  var url = new URL("https://gift.link/static/js/agglomeration.js?_fj=1");
  url.searchParams.append("_sh", (window.Shopify && window.Shopify.shop) || "");
  url.searchParams.append("_jv", version || "");
  navigator.sendBeacon(url);
}
